var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-5 mr-8",attrs:{"color":"primary","small":""},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._t("default",function(){return [_vm._v("Nieuwe Code")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }